import '@main';
import '@vendor/tw-city-selector/dk-tw-citySelector.js?201eb9a6b032a303cb6ab7f0';

u.formValidation()
  .then(() => {
    u.$ui.disableOnSubmit('#registration-form');
    u.$ui.disableOnSubmit('#registration-form-extra');
  });

$('#input-user-address').dk_tw_citySelector(
  '#input-user-address-city',
  '#input-user-address-dist',
);
